import _defineProperty from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Box, Flex, FormControl, FormLabel, IconButton, Input, InputGroup, InputRightElement, useColorModeValue as mode, useDisclosure, useMergeRefs } from '@chakra-ui/react';
import { HiEye, HiEyeOff } from 'react-icons/hi';
import { forwardRef, useRef, useState } from 'react';
export var PasswordField = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useDisclosure = useDisclosure(),
      isOpen = _useDisclosure.isOpen,
      onToggle = _useDisclosure.onToggle;

  var inputRef = useRef(null);
  var mergeRef = useMergeRefs(inputRef, ref);

  var _useState = useState(false),
      isMagic = _useState[0],
      setIsMagic = _useState[1];

  var onClickReveal = function onClickReveal() {
    onToggle();
    var input = inputRef.current;

    if (input) {
      input.focus({
        preventScroll: true
      });
      var length = input.value.length * 2;
      requestAnimationFrame(function () {
        input.setSelectionRange(length, length);
      });
    }
  };

  var allowMagic = props.allowMagic,
      inputProps = _objectWithoutProperties(props, ["allowMagic"]);

  return /*#__PURE__*/_jsxs(FormControl, {
    id: "password",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justify: "space-between",
      children: [!isMagic && /*#__PURE__*/_jsx(FormLabel, {
        children: "Password"
      }), !!allowMagic && /*#__PURE__*/_jsx(Box, {
        as: "a",
        color: mode('blue.600', 'blue.200'),
        fontWeight: "semibold",
        fontSize: "sm",
        onClick: function onClick() {
          return setIsMagic(function (v) {
            return !v;
          });
        },
        children: isMagic ? 'Use password' : 'Use magic link'
      })]
    }), !isMagic && /*#__PURE__*/_jsxs(InputGroup, {
      children: [/*#__PURE__*/_jsx(InputRightElement, {
        children: /*#__PURE__*/_jsx(IconButton, {
          bg: "transparent !important",
          variant: "ghost",
          "aria-label": isOpen ? 'Mask password' : 'Reveal password',
          icon: isOpen ? /*#__PURE__*/_jsx(HiEyeOff, {}) : /*#__PURE__*/_jsx(HiEye, {}),
          onClick: onClickReveal
        })
      }), /*#__PURE__*/_jsx(Input, _objectSpread({
        ref: mergeRef,
        name: "password",
        type: isOpen ? 'text' : 'password',
        autoComplete: "current-password",
        required: true,
        minLength: 8
      }, inputProps))]
    })]
  });
});
PasswordField.displayName = 'PasswordField';